// extracted by mini-css-extract-plugin
export default {"host":"Resource_host__8BI-9"};